import * as React from 'react';

import { useAppSelector } from 'app';
import {
  BoxColorIcon,
  FarmerColorIcon,
  PeopleLinkColorIcon,
  ShopColorIcon,
  TruckColorIcon,
  VolunteerColorIcon,
} from 'components/Icon';
import {
  CreateAccount,
  MyEntities,
  ListAccount,
} from 'containers/App/Account/components';
import { selectAppDevice } from 'slice';
import { SELECTED_ENTITY } from 'types/localStorage';
import { COLLABORATOR_TEXT, DEVICES } from 'utils';

import AccountModalDesktop from './AccountModalDesktop';
import AccountModalMobile from './AccountModalMobile';

interface AccountModalProps {
  isToggle: boolean;
  height?: number;
  directLink?: string;
}

const AccountModal = ({
  isToggle,
  directLink,
  height,
}: AccountModalProps): JSX.Element => {
  const selectedEntity = localStorage.getItem(SELECTED_ENTITY);
  const { type: entityNumberType } = selectedEntity
    ? JSON.parse(selectedEntity as string)
    : '';
  const [currentStep, setCurrentStep] = React.useState(0);
  const [visible, setVisible] = React.useState(false);
  const [isSelecting, setIsSelecting] = React.useState(false);
  const [entityType, setEntityType] = React.useState('farm');

  const handleChangeCurrentStep = (e: number) => {
    setCurrentStep(e);
  };

  const handleChangeEntityType = e => {
    setEntityType(e);
  };

  const handleChangeVisible = (e: boolean) => {
    setVisible(e);
  };

  const handleChooseAccountModal = (type: string) => {
    setEntityType(type);
    setCurrentStep(2);
  };

  const handleSelectAccount = (val: boolean) => {
    setIsSelecting(val);
  };

  const renderEntityName = (type: string) => {
    switch (type) {
      case 'farm':
        return 'Tạo tài khoản nông trại';
      case 'store':
        return 'Tạo tài khoản cửa hàng';
      case 'collaborator':
        return `Tạo tài khoản ${COLLABORATOR_TEXT.LOWERCASE}`;
      case 'warehouse':
        return 'Tạo tài khoản kho chứa';
      case 'transport':
        return 'Tạo tài khoản đơn vị vận chuyển';
      case 'volunteer':
        return 'Tạo tài khoản thiện nguyện';
      default:
        return '';
    }
  };

  const renderEntityIcon = (type: number) => {
    switch (type) {
      case 1:
        return <FarmerColorIcon height={20} width={20} />;
      case 2:
        return <ShopColorIcon height={20} width={20} />;
      case 3:
        return <PeopleLinkColorIcon height={20} width={20} />;
      case 4:
        return <BoxColorIcon height={20} width={20} />;
      case 5:
        return <TruckColorIcon height={20} width={20} />;
      case 6:
        return <VolunteerColorIcon height={20} width={20} />;
      default:
        return <></>;
    }
  };

  const listStep = [
    <MyEntities
      directLink={directLink}
      isResetData={false}
      setCurrentStep={setCurrentStep}
      setVisibleModal={setVisible}
      onSelectAccount={handleSelectAccount}
    />,
    <ListAccount isAtModal chooseAccountModal={handleChooseAccountModal} />,
    <CreateAccount
      entityType={entityType}
      setCurrentStep={setCurrentStep}
      setVisibleModal={setVisible}
    />,
  ];

  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <AccountModalDesktop
        currentStep={currentStep}
        entityType={entityType}
        handleChangeCurrentStep={handleChangeCurrentStep}
        handleChangeEntityType={handleChangeEntityType}
        handleChangeVisible={handleChangeVisible}
        height={height}
        isSelecting={isSelecting}
        isToggle={isToggle}
        listStep={listStep}
        renderEntityName={renderEntityName}
        visible={visible}
      />
    ),
    [DEVICES.MOBILE]: (
      <AccountModalMobile
        currentStep={currentStep}
        entityNumberType={entityNumberType}
        entityType={entityType}
        handleChangeCurrentStep={handleChangeCurrentStep}
        handleChangeEntityType={handleChangeEntityType}
        handleChangeVisible={handleChangeVisible}
        isSelecting={isSelecting}
        isToggle={isToggle}
        listStep={listStep}
        renderEntityIcon={renderEntityIcon}
        renderEntityName={renderEntityName}
        visible={visible}
      />
    ),
    [DEVICES.TABLET]: (
      <AccountModalMobile
        currentStep={currentStep}
        entityNumberType={entityNumberType}
        entityType={entityType}
        handleChangeCurrentStep={handleChangeCurrentStep}
        handleChangeEntityType={handleChangeEntityType}
        handleChangeVisible={handleChangeVisible}
        isSelecting={isSelecting}
        isToggle={isToggle}
        listStep={listStep}
        renderEntityIcon={renderEntityIcon}
        renderEntityName={renderEntityName}
        visible={visible}
      />
    ),
  };

  return renderElements[appDevice.device];
};

export default AccountModal;
